import axios, { InternalAxiosRequestConfig } from 'axios';
import { API_BASE_URL } from '@/config/common';
import { useCurrentOrganizationStore } from '@/store/use-current-organization-store';
import { firebaseAuth } from '@/config/firebase';

const LS_CLIENT_ID = 'ex-client-id';

const getClientId = (): string => {
  let clientId = localStorage.getItem(LS_CLIENT_ID);

  if (!clientId) {
    clientId = crypto.randomUUID();
    localStorage.setItem(LS_CLIENT_ID, clientId);
  }

  return clientId;
};

const onFulfilled = async (config: InternalAxiosRequestConfig) => {
  config.headers.set('client-id', getClientId());
  config.headers.set('request-id', crypto.randomUUID());
  config.headers.set(
    'time-zone',
    Intl.DateTimeFormat().resolvedOptions().timeZone,
  );

  // Attach a fresh Firebase ID token (the SDK auto-refreshes it). No session
  // cookie is stored — the token is minted per request from the current user.
  const idToken = await firebaseAuth.currentUser?.getIdToken();
  if (idToken) {
    config.headers.setAuthorization(`Bearer ${idToken}`);
  }

  const { currentOrganization } = useCurrentOrganizationStore();

  if (!config.headers.get('organization-slug') && currentOrganization) {
    config.headers.set('organization-slug', currentOrganization.slug);
  }

  return config;
};

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
});

apiClient.interceptors.request.use(onFulfilled);
